import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BAVBenefitListItemExtension } from './bav-benefit-list-item.extension';
import { BAVBenefitMetadataExtension } from './bav-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bav')
    .add(BenefitMetadataExtensionInterface, new BAVBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new BAVBenefitListItemExtension())
    .build(),
);
